module.exports = __webpack_public_path__ + "assets/img/diet.5c909652.png";